import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ModalRole from './ModalRole';
import {deleteKelas, showFormError, updateFieldError} from '../../features/siswaSlice';
import close from '../../assets/icons/close.svg'
import plus from '../../assets/icons/plus.svg'
import { useState } from 'react';

function KelasSelect() {
    const dispatch = useDispatch()
    const [modalActive, setModalActive] = useState(false)
    const { kelas } = useSelector(
        (state) => state.siswa
    );

    useEffect(() => {
        if (kelas != null) {
            dispatch(updateFieldError({
                field: 'kelas',
                error: ''
            }))
            dispatch(showFormError('kelas'));
        }
    }, [kelas, dispatch])

    return (
        <div className='wrapper-container-jabatan'>


            {
                kelas && (
                    <div className='container-jabatan' style={{width:"700px"}}>
                        <p>{kelas.category}</p>
                        <img src={close} alt="" onClick={() => dispatch(deleteKelas())} />
                    </div>
                )
            }

            {!kelas && (
                <div className='container-jabatan btn-plus'  onClick={() => setModalActive(true)}>
                    <img src={plus} alt="" />
                </div>
            )}
            {modalActive && <ModalRole onClose={() => setModalActive(false)} />}
        </div>
    )
}

export default KelasSelect